'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basil = require('basil.js');

var _basil2 = _interopRequireDefault(_basil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities for saving and retrieving data from local/session storage as well as a cookie backup.
 * @module StorageUtils
 */
var StorageUtils = {
    /**
     * Sets a value in the selected storage type.
     * @static
     * @function set
     * @param {String} key - The key to save the value as.
     * @param {*} value - The value to set. Values will be run through `JSON.stringify()`.
     * @param {String} [type='local'] - The type of storage to use. Available types include 'local', 'session', and 'cookie'.
     * @param {Number} [cookieExpires=1] - Days when a cookie will expire if the type is set to 'cookie'.
     * @example
     * StorageUtils.set('foo', 'bar');
     * @returns {void}
     */
    set: function set(key, value) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
        var cookieExpires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

        var val = JSON.stringify(value);

        switch (type) {
            case 'local':
                _basil2.default.localStorage.set(key, val);
                break;

            case 'session':
                _basil2.default.sessionStorage.set(key, val);
                break;

            case 'cookie':
                _basil2.default.cookie.set(key, val, {
                    expireDays: cookieExpires
                });
                break;
        }
    },


    /**
     * Retrieves a value from the selected storage type.
     * @static
     * @function get
     * @param {String} key - The key to retrieve the value of. Values will be parsed using `JSON.parse()`.
     * @param {String} [type='local'] - The type of storage to retrieve from. Available types include 'local', 'session', and 'cookie'.
     * @example
     * StorageUtils.get('foo');
     * @returns {String} - The value at the specified key.
     */
    get: function get(key) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';

        var storageType = void 0;

        switch (type) {
            case 'local':
                storageType = 'localStorage';
                break;

            case 'session':
                storageType = 'sessionStorage';
                break;

            case 'cookie':
                storageType = 'cookie';
                break;
        }

        // wrap in a try/catch in case an already saved or old value is not JSON parseable
        try {
            return JSON.parse(_basil2.default[storageType].get(key));
        } catch (err) {
            return _basil2.default[storageType].get(key);
        }
    },


    /**
     * Removes a stored value from the specified storage type.
     * @static
     * @function remove
     * @param {String} key - The key of the value to remove.
     * @param {String} [type='local'] - The type of storage to remove from. Available types include 'local', 'session', and 'cookie'.
     * @example
     * StorageUtils.remove('foo');
     * @returns {void}
     */
    remove: function remove(key) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';

        var storageType = void 0;

        switch (type) {
            case 'local':
                storageType = 'localStorage';
                break;

            case 'session':
                storageType = 'sessionStorage';
                break;

            case 'cookie':
                storageType = 'cookie';
                break;
        }

        _basil2.default[storageType].remove(key);
    }
};

exports.default = StorageUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spothero/utils/lib/storage/storage.js
// module id = 277
// module chunks = 0